import progressConstants from '../constants';

export function progress(state = { open: false, message: '' }, action) {
    switch (action.type) {
        case progressConstants.HIDE_PROGRESS:
            return {
                open: false,
                message: ''
            }
        case progressConstants.REPORT_PROGRESS:
            return {
                open: true,
                message: action.message
            }
        default:
            return state;
    }
}